import Load from 'components/Load';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React from 'react';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const HostOnboardingContainer = Load(
  () =>
    import(/* webpackChunkName: "host-onboarding" */ './pages/HostOnboarding'),
);
const HostOnboardingOriginalsContainer = Load(
  () =>
    import(
      /* webpackChunkName: "host-onboarding" */ './pages/HostOnboardingOriginals'
    ),
);
const HostOnboardingJoinContainer = Load(
  () =>
    import(
      /* webpackChunkName: "host-onboarding" */ './pages/HostOnboardingJoin'
    ),
);
const HostOnboardingFeedbackContainer = Load(
  () =>
    import(
      /* webpackChunkName: "host-onboarding" */ './pages/HostOnboardingFeedback'
    ),
);
const HostOnboardingVideoContainer = Load(
  () =>
    import(
      /* webpackChunkName: "host-onboarding" */ './pages/HostOnboardingVideo'
    ),
);

const HostOnboardingPageRoute = [
  <NavigationableLayout
    key="host-onboarding-originals-join"
    path={`${basePath}/host/onboarding/withlocals-originals/:tier/join`}
    hideFooter
    component={HostOnboardingJoinContainer}
    showBottomNavigation
    noNavbar={isCordova()}
    nonFixedNavbar
  />,
  <NavigationableLayout
    key="host-onboarding-originals"
    path={`${basePath}/host/onboarding/withlocals-originals`}
    hideFooter
    component={HostOnboardingOriginalsContainer}
    showBottomNavigation
    noNavbar={isCordova()}
    nonFixedNavbar
  />,
  <NavigationableLayout
    key="host-onboarding-feedback"
    path={`${basePath}/host/onboarding/feedback`}
    hideFooter
    component={HostOnboardingFeedbackContainer}
    showBottomNavigation
    noNavbar={isCordova()}
    nonFixedNavbar
  />,
  <NavigationableLayout
    key="host-onboarding"
    path={`${basePath}/host/onboarding/screening`}
    hideFooter
    component={HostOnboardingVideoContainer}
    showBottomNavigation
    noNavbar={isCordova()}
    nonFixedNavbar
  />,
  <NavigationableLayout
    key="host-onboarding"
    path={`${basePath}/host/onboarding`}
    hideFooter
    component={HostOnboardingContainer}
    showBottomNavigation
    noNavbar={isCordova()}
    nonFixedNavbar
  />,
];

export default HostOnboardingPageRoute;
